module.exports = __webpack_public_path__ + "SamsungOne-300.924c0964d257623764dd.ttf";


//////////////////
// WEBPACK FOOTER
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/assets/layout/fonts/SamsungOne-300.ttf
// module id = ../../../../../src/assets/layout/fonts/SamsungOne-300.ttf
// module chunks = styles